<script setup lang="ts">
import axios from 'axios';
import { inject, onMounted, ref } from 'vue';

interface ExchangeData {
  code: string,
  name: string,
  buy: number,
  sale: number,
  cbRf: number
}

const view = inject("view", "mobile")
const getMonthString = (date: Date) => ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'][date.getMonth()];

const data = ref<ExchangeData[]>()
const date = ref()

const getDate = () => {
  const currentDate = new Date
  return {
    hour: currentDate.getHours(),
    day: currentDate.getDate(),
    month: getMonthString(currentDate),
    year: currentDate.getFullYear()
  }
}

const getExcangeData = async () => {
  const rawData = await axios.get('https://aebonline-api.albank.ru/api/ExchangeRate/v3?platgorm=0')
  const result = rawData.data.result.currencies as ExchangeData[]
  return result
}

onMounted(async () => {
  data.value = await getExcangeData()
  date.value = getDate()  
})
</script>

<template>
  <div class="exchange">
    <h4>Курсы валют</h4>
    <p v-if="date && view == 'mobile'" class="actuality">Актуально на {{ date.hour }}:00 {{ date.day }} {{ date.month }} {{ date.year }} </p>
    <div class="exchange__content">
      
      <div class="exchange__row">
        <h6 class="col-1">Валюта</h6>
        <h6 class="col-2">Продать</h6>
        <h6 class="col-3">Купить</h6>
      </div>
      <hr />

      <div v-for="currency in data" :key="currency.name" class="exchange__row">
        <h5 class="col-1">{{ data? currency.name : 0 }}</h5>
        <h5 class="col-2">{{ data? currency.buy.toFixed(2) : 0 }}</h5>
        <h5 class="col-3">{{ data? currency.sale.toFixed(2) : 0}}</h5>
      </div>
      
    </div>

    <a
      class="link-button" 
      href="https://albank.ru/ru/more/info/exchange/" 
    >
      <img 
        src="/assets/icons/arrow-right.svg" 
        alt="Arrow right"
        class="arrow-right"
      />
    </a>
    <p v-if="date && view != 'mobile'" class="actuality">Актуально на {{ date.hour }}:00 {{ date.day }} {{ date.month }} {{ date.year }} </p>
  </div>
</template>

<style lang="scss" scoped>
.exchange {
  gap: 24px;
  padding: 40px;
  display: flex;
  flex: 1 300px;
  color: #27303E;
  position: relative;
  border-radius: 32px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  background: var(--color-mono-50);

  @media screen and (max-width: 800px) {
    gap: 8px;
    padding: 20px;
    background: #EAEFF4;
  }

  .link-button {
    padding: 12px;
    display: block;
    border-radius: 12px;
    background: var(--color-mono-0);
    
    @media screen and (max-width: 800px) {
      margin-left: auto;
    }
  }

  h4 {
    font-size: var(--font-size-l);
    
    @media screen and (max-width: 800px) {
      font-size: var(--font-size-s);
    }
  }

  &__content {
    gap: 16px;
    width: 100%;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 800px) {
      gap: 14px;
      margin-top: 8px;
    }

    p {
      margin: 0;
      padding: 0;
    }

    hr {
      margin: 0;
      border: var(--color-mono-100) 1px solid;
    }
  }

  &__row {
    display: flex;

    .col-1 {
      flex: 3;
      font-weight: var(--font-weight-light);
    }

    .col-2, .col-3 {
      flex: 2;
      font-weight: var(--font-weight-medium);
    }

    @media screen and (max-width: 800px) {
      .col-1, .col-2, .col-3 {
        flex: 1;
      }
    }

    h5 {
      color: var(--color-mono-800);
      font-size: var(--font-size-m);
      @media screen and (max-width: 800px) {
        font-size: var(--font-size-s);
      }
    }

    h6 {
      font-size: var(--font-size-s);
      color: var(--color-mono-800);
      font-weight: var(--font-weight-regular) !important;
    
      @media screen and (max-width: 800px) {
        color: #5A6574;
        font-weight: var(--font-weight-light) !important;
      }
    }
  }

  .actuality {
    right: 40px;
    bottom: 40px;
    position: absolute;
    color: var(--color-mono-300);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-light);

    @media screen and (max-width: 800px) {
      top: 0;
      right: 0;
      position: relative;
    }
  }
}
</style>

